import { api } from '@/core/lib/api-client';
import { GetAnalyticsDto } from '@link-in-bio/domain';

export const getCountryStats = (getAnalyticsDto: GetAnalyticsDto) => {
  return api.post('/analytics/get-country-stats', getAnalyticsDto);
};
